import type {
	CreateEventFormData,
	UpdateEventFormData,
} from "~/components/events/utils";
import { api } from "./client";
import type {
	APIResponse,
	CategorizedEvents,
	Event,
	EventDetailsResponse,
	InviteResponse,
	ResolveMapUrlResponse,
	Rsvp,
	RsvpRequest,
} from "./types";

export const eventApi = {
	createEvent: async (data: CreateEventFormData) => {
		const formData = new FormData();

		// Add each field directly to form data
		for (const [key, value] of Object.entries(data)) {
			formData.append(key, value as string);
		}

		return api<APIResponse<Event>>("/event/create", {
			method: "POST",
			body: formData,
		});
	},
	updateEvent: async (eventId: string, data: UpdateEventFormData) => {
		const formData = new FormData();

		// Add each field directly to form data
		for (const [key, value] of Object.entries(data)) {
			formData.append(key, value as string);
		}

		return api<APIResponse<Event>>(`/event/${eventId}`, {
			method: "PUT",
			body: formData,
		});
	},
	getEvents: async () => {
		return api<APIResponse<CategorizedEvents>>("/event/all");
	},
	getEvent: async (slug: string) => {
		return api<APIResponse<EventDetailsResponse>>(`/event/${slug}`);
	},
	getEventInvite: async (slug: string) => {
		return api<APIResponse<InviteResponse>>(`/event/${slug}/invite`);
	},
	submitRsvp: async (eventSlug: string, data: RsvpRequest) => {
		return api<APIResponse<Rsvp>>(`/event/${eventSlug}/rsvp`, {
			method: "POST",
			body: data,
		});
	},
	cancelEvent: async (eventSlug: string, data: { reason: string }) => {
		return api<APIResponse<void>>(`/event/${eventSlug}/cancel`, {
			method: "POST",
			body: data,
		});
	},
	restoreEvent: async (eventSlug: string) => {
		return api<APIResponse<void>>(`/event/${eventSlug}/restore`, {
			method: "POST",
		});
	},
	resolveGoogleMapsShortLink: async (url: string) => {
		return api<APIResponse<ResolveMapUrlResponse>>(
			`/utils/resolve-map-url?url=${url}`,
		);
	},
	generateCoverImage: async (eventTitle: string, eventDescription?: string) => {
		return api<APIResponse<{ url: string }>>("/event/generate-cover-image", {
			method: "POST",
			body: {
				eventTitle,
				eventDescription,
			},
		});
	},
};
